<template>
  <div class="box">
    <div v-if="label !== ' '">
      <h3>{{ label }}</h3>
      <br />
      <p>Most recent first</p>
    </div>
    <div v-if="employmentStatusType === 0 || employmentStatusType == 3">
      <div class="columns is-multiline">
        <div class="column is-6">
          <div class="field">
            <label class="label">Employer<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
            <div class="control">
              <!-- <vue-google-autocomplete
                :id="instanceName + 'compName'"
                :key="validationName + 'employer'"
                ref="compName"
                types="establishment"
                classname="input"
                type="text"
                placeholder="Type to search for company name"
                v-on:placechanged="getAddressData"
                v-on:change="onChangeAutoComplete"
                :enable-geolocation="false"
                autocomplete="disabled"
                :value="internalValue.employer">
              </vue-google-autocomplete> -->
              <input type="text" :name="validationName + 'employer'" v-validate="{ 'required': required, 'max': 30 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'employer') }" :data-vv-scope="scope" data-vv-as="employer" placeholder="Employer" v-model="internalValue.employer">
              <span v-show="errors.has(validationName + 'employer')" class="help is-danger">
                <i v-show="errors.has(validationName + 'employer')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'employer') }}
              </span>
              <pop-fill-control v-if="popFillData" title="Click to copy employer" :fillableValue="popFillData.companyName" :onFillAction="onRestoreEmployer"></pop-fill-control>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label">Job Title<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
            <div class="control">
              <input :name="validationName + 'jobTitle'" :key="validationName + 'jobTitle'" v-validate="{ 'required': required, 'max': 26 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'jobTitle') }" :data-vv-scope="scope" data-vv-as="job title" type="text" placeholder="Job Title" v-model="internalValue.jobTitle">
              <span v-show="errors.has(validationName + 'jobTitle')" class="help is-danger">
                <i v-show="errors.has(validationName + 'jobTitle')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'jobTitle') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="address-capture">
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 1<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'address1'" :key="validationName + 'address1'" v-validate="{ 'required': required, 'max': 60 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address1') }" :data-vv-scope="scope" data-vv-as="address line 1" type="text" placeholder="Address Line 1" v-model="internalValue.address1">
                <span v-show="errors.has(validationName + 'address1')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'address1')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'address1') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy address1" :fillableValue="popFillData.address1" :onFillAction="onRestoreAddress1"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Address Line 2</label>
              <div class="control">
                <input :name="validationName + 'address2'" :key="validationName + 'address2'"  v-validate="{'max' : 60}" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'address2') }" :data-vv-scope="scope" data-vv-as="address line 2" type="text" placeholder="Address Line 2" v-model="internalValue.address2">
                <span v-show="errors.has(validationName + 'address2')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'address2')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'address2') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy address2" :fillableValue="popFillData.address2" :onFillAction="onRestoreAddress2"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">City<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'city'" :key="validationName + 'city'" v-validate="{ 'required': required, 'max': 20 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'city') }" :data-vv-scope="scope" data-vv-as="city" type="text" placeholder="City" v-model="internalValue.city">
                <span v-show="errors.has(validationName + 'city')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'city')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'city') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy city" :fillableValue="popFillData.city" :onFillAction="onRestoreCity"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">State<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <multiselect
                  :multiple="false"
                  :name="validationName + 'state'"
                  :key="validationName + 'state'"
                  v-validate="{ 'required': required }"
                  :class="{ 'is-danger': errors.has(validationName + 'state') }"
                  :data-vv-scope="scope"
                  data-vv-as="state"
                  placeholder="Select State"
                  label="name"
                  track-by="id"
                  :options="stateOptions"
                  :searchable="true"
                  v-model="selectedState">
                </multiselect>
                <span v-show="errors.has(validationName + 'state')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'state')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'state') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy state" :fillableValue="popFillData.state" :onFillAction="onRestoreState"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Zip Code<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'postalCode'" :key="validationName + 'postalCode'" v-validate="{ 'required': required, 'max': 5 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'postalCode') }" :data-vv-scope="scope" data-vv-as="zip code" type="text" placeholder="Zip Code" v-model="internalValue.postalCode">
                <span v-show="errors.has(validationName + 'postalCode')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'postalCode')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'postalCode') }}
                </span>
                <pop-fill-control v-if="popFillData" title="Click to copy zip code" :fillableValue="popFillData.postalCode" :onFillAction="onRestorePostalCode"></pop-fill-control>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Country<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'country'" :key="validationName + 'country'" :disabled="true" v-validate="{ 'required': required }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'country') }" :data-vv-scope="scope" data-vv-as="country" type="text" placeholder="Country" v-model="internalValue.country">
                <span v-show="errors.has(validationName + 'country')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'country')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'country') }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label">Employer Office No.<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'employerOffice'" :key="validationName + 'employerOffice'" v-validate="{ 'required': required, 'min': 16, 'max': 16 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'employerOffice') }" :data-vv-scope="scope" data-vv-as="employer office no." type="tel"  placeholder="+1(999)-999-9999" v-mask="'+1(###)-###-####'" v-model="internalValue.employerOffice">
                <span v-show="errors.has(validationName + 'employerOffice')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'employerOffice')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'employerOffice') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Monthly Income<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control has-icons-left">
                <money :name="validationName + 'grossIncome'" :key="validationName + 'grossIncome'" v-validate="{ 'required': required, 'decimal': false, 'min_value':1, 'max_value': 999999 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'grossIncome') }" :data-vv-scope="scope" data-vv-as="monthly income" type="text" placeholder="0" v-bind="$globalMoneyFormatNoDecimal" v-model="internalValue.grossIncome"></money>
                <span v-show="errors.has(validationName + 'grossIncome')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'grossIncome')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName +'grossIncome') }}
                </span>
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Years (Employed)<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'years'" :key="validationName + 'years'" v-validate="yearValidationFormulae" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'years') }" :data-vv-scope="scope" data-vv-as="years" type="number" placeholder="##" @focus="$event.target.select()" v-model="internalValue.years">
                <span v-show="errors.has(validationName + 'years')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'years')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'years') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Months (Employed)<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <input :name="validationName + 'months'" :key="validationName + 'months'" v-validate="monthValidationFormulae" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'months') }" :data-vv-scope="scope" data-vv-as="months" type="number" placeholder="##" @focus="$event.target.select()" v-model="internalValue.months">
                <span v-show="errors.has(validationName + 'months')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'months')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'months') }}
                </span>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <div class="control has-icons-left">
                <b-checkbox
                  :native-value="false"
                  name="noOtherIncome"
                  type="is-info"
                  v-model="noOtherIncome">
                  No Other Income
                </b-checkbox>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Other Monthly Income<b-icon pack="fas" :icon="otherIncomeEntered || otherIncomeSourceEntered ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control has-icons-left">
                <money :name="validationName + 'otherIncome'" :key="validationName + 'otherIncome'" :disabled="noOtherIncome" v-validate="otherIncomeSourceEntered ? 'required|decimal:0|min_value:0|max_value:999999' : 'decimal:0'" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'otherIncome') }" :data-vv-scope="scope" data-vv-as="other income" type="text" placeholder="0" v-bind="$globalMoneyFormatNoDecimal" v-model="internalValue.otherIncome"></money>
                <span v-show="errors.has(validationName + 'otherIncome')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'otherIncome')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'otherIncome') }}
                </span>
                <span class="icon is-small is-left">
                  <i class="fas fa-dollar-sign"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label">Other Income Source<b-icon pack="fas" :icon="otherIncomeEntered || otherIncomeSourceEntered ? 'star' : ''" class="fa-ss"></b-icon></label>
              <div class="control">
                <multiselect
                  :multiple="false"
                  :name="validationName + 'otherIncomeSource'"
                  :key="validationName + 'otherIncomeSource'"
                  v-validate="{ 'required': otherIncomeEntered }"
                  :class="{ 'is-danger': errors.has(validationName + 'otherIncomeSource') }"
                  :data-vv-scope="scope"
                  data-vv-as="other income source"
                  placeholder="Select Other Income Source"
                  label="altName"
                  track-by="id"
                  :disabled="noOtherIncome"
                  :options="definedTypes.incomeSourceType.options"
                  :searchable="true"
                  v-model="selectedIncomeSourceType">
                </multiselect>
                <span v-show="errors.has(validationName + 'otherIncomeSource')" class="help is-danger">
                  <i v-show="errors.has(validationName + 'otherIncomeSource')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'otherIncomeSource') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="employmentStatusType === 2 || employmentStatusType === 4">
      <div class="column is-12">
        <div class="field">
          <label class="label">Monthly Income<b-icon pack="fas" :icon="required ? 'star' : ''" class="fa-ss"></b-icon></label>
          <div class="control has-icons-left">
            <money :name="validationName + 'grossIncome'" :key="validationName + 'grossIncome'" v-validate="{ 'required': required, 'decimal': false, 'min_value':1, 'max_value': 999999 }" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'grossIncome') }" :data-vv-scope="scope" data-vv-as="monthly income" type="text" placeholder="0" v-bind="$globalMoneyFormatNoDecimal" v-model="internalValue.grossIncome"></money>
            <span v-show="errors.has(validationName + 'grossIncome')" class="help is-danger">
              <i v-show="errors.has(validationName + 'grossIncome')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName +'grossIncome') }}
            </span>
            <span class="icon is-small is-left">
              <i class="fas fa-dollar-sign"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="field">
          <div class="control has-icons-left">
            <b-checkbox
              :native-value="false"
              name="noOtherIncome"
              type="is-info"
              v-model="noOtherIncome">
              No Other Income
            </b-checkbox>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="field">
          <label class="label">Other Monthly Income<b-icon pack="fas" :icon="otherIncomeEntered || otherIncomeSourceEntered ? 'star' : ''" class="fa-ss"></b-icon></label>
          <div class="control has-icons-left">
            <money :name="validationName + 'otherIncome'" :key="validationName + 'otherIncome'" :disabled="noOtherIncome" v-validate="otherIncomeSourceEntered ? 'required|decimal:0|min_value:0|max_value:999999' : 'decimal:0'" :class="{ 'input': true, 'is-danger': errors.has(validationName + 'otherIncome') }" :data-vv-scope="scope" data-vv-as="other income" type="text" placeholder="0" v-bind="$globalMoneyFormatNoDecimal" v-model="internalValue.otherIncome"></money>
            <span v-show="errors.has(validationName + 'otherIncome')" class="help is-danger">
              <i v-show="errors.has(validationName + 'otherIncome')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'otherIncome') }}
            </span>
            <span class="icon is-small is-left">
              <i class="fas fa-dollar-sign"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="field">
          <label class="label">Other Income Source<b-icon pack="fas" :icon="otherIncomeEntered || otherIncomeSourceEntered ? 'star' : ''" class="fa-ss"></b-icon></label>
          <multiselect
            :multiple="false"
            :id="validationName + 'otherIncomeSource'"
            :name="validationName + 'otherIncomeSource'"
            :key="validationName + 'otherIncomeSource'"
            v-validate="{ 'required': otherIncomeEntered }"
            :class="{ 'is-danger': errors.has(validationName + 'otherIncomeSource') }"
            :data-vv-scope="scope"
            data-vv-as="other income source"
            placeholder="Select Other Income Source"
            label="altName"
            track-by="id"
            :disabled="noOtherIncome"
            :options="definedTypes.incomeSourceType.options"
            :searchable="true"
            v-model="selectedIncomeSourceType">
          </multiselect>
          <span v-show="errors.has(validationName + 'otherIncomeSource')" class="help is-danger">
            <i v-show="errors.has(validationName + 'otherIncomeSource')" class="fas fa-exclamation-triangle"></i>{{ errors.first(validationName + 'otherIncomeSource') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueGoogleAutocomplete from 'vue-google-autocomplete'
import PopFillControl from '@/components/generic/PopFillControl'

import { createNamespacedHelpers } from 'vuex'
const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'WorkHistory',
  components: {
    // 'vue-google-autocomplete': VueGoogleAutocomplete
    'pop-fill-control': PopFillControl
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ' '
    },
    required: {
      type: Boolean,
      default: false
    },
    employmentStatusType: {
      type: Number,
      default: 0
    },
    scope: {
      type: String,
      default: null
    },
    popFillData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      instanceName: this.$uuid.v4(),
      internalValue: null,
      selectedIncomeSourceType: null,
      selectedState: null,
      addressSelected: false,
      noOtherIncome: false,
      regEx: /([^\w ]|_)/g
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    yearValidationFormulae: function () {
      return this.monthsNotEntered ? (this.required ? 'required|min_value:1' : '') : 'min_value:0'
    },
    monthValidationFormulae: function () {
      return this.yearsNotEntered ? (this.required ? 'required|min_value:1|max_value:12' : '') : 'min_value:0|max_value:12'
    },
    validationName: function () {
      return (this.scope) ? this.scope + '.' + this.instanceName + '.' : this.instanceName + '.'
    },
    otherIncomeSourceEntered: function () {
      return this.internalValue.otherIncomeSource
    },
    otherIncomeEntered: function () {
      return this.internalValue.otherIncome > 0
    },
    monthsNotEntered: function () {
      return !this.internalValue.months || this.internalValue.months <= 0
    },
    yearsNotEntered: function () {
      return !this.internalValue.years || this.internalValue.years <= 0
    },
    stateOptions: function () {
      return this.definedTypes.usStateLookup.options
    }
  },
  methods: {
    getAddressData: function (addressData, place, id) {
      this.internalValue.employer = place.name
      this.addressSelected = true
      const addressComponents = place.address_components
      this.internalValue.address1 = ''
      this.internalValue.address2 = ''
      this.internalValue.address3 = ''
      this.internalValue.address4 = ''
      this.internalValue.postalCode = ''
      this.internalValue.state = ''
      this.internalValue.city = ''
      this.internalValue.gpsAddress = ''
      this.internalValue.country = ''

      for (var i = 0; i < addressComponents.length; i++) {
        var addressType = addressComponents[i].types[0]
        // if (addressType === 'street_number') {
        //   var streetNumber = addressComponents[i].short_name
        //   this.internalValue.address1 = streetNumber
        // }

        // if (addressType === 'route') {
        //   var streetName = addressComponents[i].short_name
        //   this.internalValue.address1 += ' ' + streetName
        // }

        // if (addressType === 'neighborhood') {
        //   const vicinity = addressComponents[i].short_name
        //   this.internalValue.address2 = vicinity
        // }

        if (addressType === 'locality') {
          var city = addressComponents[i].short_name
          this.internalValue.city = city
        }

        if (!this.internalValue.city || this.internalValue.city === '') {
          var vicinity = place.vicinity
          this.internalValue.city = vicinity
        }

        if (addressType === 'administrative_area_level_1') {
          var state = addressComponents[i].long_name
          this.internalValue.state = state
          this.selectedState = this.definedTypes.usStateLookup.options.find((x) => x.name === state)
        }

        if (addressType === 'country') {
          var country = addressComponents[i].long_name
          this.internalValue.country = country
        }

        if (addressType === 'postal_code') {
          var postalCode = addressComponents[i].short_name
          this.internalValue.postalCode = postalCode
        }
      }

      if (addressData.latitude && addressData.longitude) {
        this.internalValue.gpsAddress = addressData.latitude + ',' + addressData.longitude
      }
      this.$emit('input', this.internalValue)
    },
    onRestoreEmployer: function () {
      this.internalValue.employer = this.popFillData.companyName
    },
    onRestoreAddress1: function () {
      this.internalValue.address1 = this.popFillData.address1
    },
    onRestoreAddress2: function () {
      this.internalValue.address2 = this.popFillData.address2
    },
    onRestoreCity: function () {
      this.internalValue.city = this.popFillData.city
    },
    onRestoreState: function () {
      this.selectedState = this.popFillData.state ? this.definedTypes.usStateLookup.options.find((x) => x.name === this.popFillData.state) : null
    },
    onRestorePostalCode: function () {
      this.internalValue.postalCode = this.popFillData.postalCode
    },
    // onChangeAutoComplete: function () {
    //   if (this.addressSelected) {
    //     this.$refs.compName.update(this.internalValue.employer)
    //     this.addressSelected = false
    //   }
    //   this.internalValue.employer = this.$refs.compName._data.autocompleteText
    // },
    initValues: function () {
      this.selectedIncomeSourceType = this.value.otherIncomeSource ? this.definedTypes.incomeSourceType.options.find((x) => x.name === this.value.otherIncomeSource || x.altName === this.value.otherIncomeSource) : null
      this.value.country = 'United States'
      this.selectedState = this.value.state ? this.definedTypes.usStateLookup.options.find((x) => x.name === this.value.state) : null
      if (!this.selectedIncomeSourceType) {
        this.noOtherIncome = true
      }
    }
  },
  watch: {
    selectedIncomeSourceType: function (newValue, oldValue) {
      if (newValue !== undefined) {
        this.internalValue.otherIncomeSource = newValue.altName
        this.$emit('input', this.internalValue)
      }
    },
    'internalValue.employer': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.employer = newValue.replace(this.regEx, ' ')
      }

      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.internalValue.employer = titleCaseVersion
      }
    },
    'internalValue.address1': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.address1 = newValue.replace(this.regEx, ' ')
      }
    },
    'internalValue.address2': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.address2 = newValue.replace(this.regEx, ' ')
      }
    },
    'internalValue.city': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.city = newValue.replace(this.regEx, ' ')
      }

      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.internalValue.city = titleCaseVersion
      }
    },
    'internalValue.country': function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.country = newValue.replace(this.regEx, ' ')
      }

      const titleCaseVersion = (newValue) ? this.$toTitleCase(newValue) : newValue
      if (titleCaseVersion !== newValue) {
        this.internalValue.country = titleCaseVersion
      }
    },
    selectedState: function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.state = newValue.name
        this.$emit('input', this.internalValue)
      }
    },
    noOtherIncome: function (newValue, oldValue) {
      if (newValue) {
        this.internalValue.otherIncomeSource = null
        this.internalValue.otherIncome = null
      }
    }
  },
  mounted: function () {
    this.initValues()

    const that = this
    setTimeout(function () {
      if (that.$refs && that.$refs.address) {
        that.$refs.address.$el.setAttribute('autocomplete', 'disabled')
      }
    }, 250)
  },
  created: function () {
    this.internalValue = this.value
  }
}
</script>

<style scoped>
  .flat-table {
    font-family: sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 0.8rem;
    overflow: auto;
    width: 100%;
    border-collapse:separate;
    border-radius: 6px;
    -moz-border-radius:6px;
    -webkit-border-radius: 6px;
  }

  .flat-table th {
    background-color: #41b883;
    color: white;
    font-weight: normal;
    padding: 10px 15px;
  }

  .flat-table td {
    background-color: rgb(238, 238, 238);
    color: rgb(111, 111, 111);
    padding: 10px 15px;
  }

  .flat-table th:first-child {
    border-radius: 6px 0 0 0;
  }

  .flat-table th:last-child {
    border-radius: 0 6px 0 0;
  }

  .flat-table tr:last-child td:first-child {
    border-radius: 0 0 0 6px;
  }

  .flat-table tr:last-child td:last-child {
    border-radius: 0 0 6px 0;
  }

  .box {
    background-color: #f6f8fa;
  }

  /* ::-webkit-input-placeholder {
      color: #fff;
      background: #fff7e3;
      outline: 20px solid #fff7e3;
  }

  ::-ms-input-placeholder {
      color: #fff;
      background: #fff7e3;
      outline: 20px solid #fff7e3;
  }

  ::-moz-placeholder {
      color: #fff;
      background: #fff7e3;
      outline: 20px solid #fff7e3;
  } */
</style>
